<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ 'Doc::CopyOptions' | abpLocalization }}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="button-space my-2">
      <button
        class="btn btn-outline-primary-1"
        [ngClass]="{ active: targetedDocRole === DocRole.CustomerQuote }"
        (click)="setTargetedDocRole(DocRole.CustomerQuote)"
      >
        {{ DocRole.CustomerQuote | displayName: enumerationTypeStore.docRoles() }}
      </button>
      <button
        class="btn btn-outline-primary-2"
        [ngClass]="{ active: targetedDocRole === DocRole.CustomerSalesPurchase }"
        (click)="setTargetedDocRole(DocRole.CustomerSalesPurchase)"
      >
        {{ DocRole.CustomerSalesPurchase | displayName: enumerationTypeStore.docRoles() }}
      </button>
    </div>

    @if (targetedDocRole === DocRole.CustomerQuote) {
      <div class="row">
        <div class="col mb-3">
          <label for="daybookId" class="form-label text-primary" dwInputRequired>
            {{ 'Doc::DayBook' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="daybookId"
            formControlName="daybookId"
            bindLabel="name.current"
            bindValue="id"
            [items]="daybooks"
          >
          </ng-select>
        </div>
      </div>
    }

    @if (isPriceComputationAvailable) {
      <div class="row">
        <div class="col mb-3">
          <input
            class="me-2 form-check-input"
            type="checkbox"
            role="switch"
            id="reevaluateTariff"
            formControlName="reevaluateTariff"
          />
          <label for="reevaluateTariff" class="form-check-label text-primary">
            {{ 'Doc::ReevaluateTariff' | abpLocalization }}
          </label>
        </div>
      </div>
    }
    <div class="row">
      <div class="col">
        <input
          class="me-2 form-check-input"
          type="checkbox"
          role="switch"
          id="copyAnnexes"
          formControlName="copyAnnexes"
        />
        <label for="copyAnnexes" class="form-check-label text-primary">
          {{ 'Doc::WithAnnexes' | abpLocalization }}
        </label>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary ms-2" (click)="modal.close()">
    {{ 'ERP::Cancel' | abpLocalization }}
  </button>
  <button class="btn btn-primary ms-2" (click)="clone()">
    {{ 'Doc::Duplicate' | abpLocalization }}
  </button>
</div>
